import { DateTime } from "luxon";

import { ReportConfig } from "lib/generated/admin-api";
import { ReportMetadata } from "./ReportSectionBuilder";

function validateMetadata(metadata: ReportMetadata): boolean {
  return !!(metadata.companyId && metadata.label.length > 0 && metadata.title.length > 0);
}

export function extractMetadata(report: ReportConfig): ReportMetadata | undefined {
  const metadata: ReportMetadata = {
    companyId: report.companyId,
    teamId: report.teamId,
    adminNotes: report.adminNotes,
    title: report.reportData.title,
    reportType: report.reportType,
    creatorId: report.creatorId,
    label: report.label,
    publishedAt: report.publishedAt,
    reportId: report.id,
  };
  return validateMetadata(metadata) ? metadata : undefined;
}

export function formatReportDate(date: string): string {
  return DateTime.fromFormat(date, "yyyy-MM-dd").toFormat("MMM d, yyyy");
}
